import * as React from "react";
import { observer, inject } from "mobx-react";
import { TypeaheadSelection } from "uitk-react-typeahead";
import { UitkLayoutGridItem, UitkLayoutGrid, UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { GroundTransportLocationField } from "./GroundTransportLocationField";
import { GroundTransportSwitch } from "./GroundTransportSwitch";
import { ACTION_DONE, getTracker } from "src/utils/TrackingUtils";
import { DefaultLocationProps } from "src/components/shared/Location/typings";
import { GroundTransportationLocationState } from "src/stores/wizard/state/car/GroundTransportationLocationState";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";

interface GroundTransportationLocationProps extends DefaultLocationProps {
  groundTransportationLocationState: GroundTransportationLocationState;
}

export const GroundTransportLocation: React.FunctionComponent<GroundTransportationLocationProps> = inject(
  "context",
  "routeStore",
  "analytics"
)(
  observer(
    ({ context, routeStore, groundTransportationLocationState, colSpan, setInputsRefs, lobState, analytics }) => {
      if (!context || !routeStore) {
        // Check for injected stores
        return null;
      }

      const {
        originConfig,
        location,
        originInvalidKey,
        destinationConfig,
        destinationInvalidKey,
      } = groundTransportationLocationState;

      const onOriginLocationFieldUpdate = (selection: TypeaheadSelection) => {
        groundTransportationLocationState.updateOriginSelection(selection);
        tracker.trackEvent(originRfrr + ACTION_DONE);
      };

      const onDestinationLocationFieldUpdate = (selection: TypeaheadSelection) => {
        groundTransportationLocationState.updateDestinationSelection(selection);
        tracker.trackEvent(destinationRfrr + ACTION_DONE);
      };

      const onSwapTypeheadLocations = () => {
        groundTransportationLocationState.swapTypeheadLocations();
      };

      const originRfrr = "origin.";
      const destinationRfrr = "destination.";

      const track = (event: string) => {
        tracker.trackEvent(event);
      };

      const tracker = getTracker(lobState.trackingEnabled, analytics, lobState.moduleName);
      const lcoationFieldColSpan: UitkLayoutConditionalGridSpan = { medium: 6 };
      const smallViewColSpan: UitkLayoutConditionalGridSpan = { small: "all" };
      const switchColSpan: UitkLayoutConditionalGridSpan = { medium: 1 };

      React.useEffect(() => {
        groundTransportationLocationState.updateStateFromCookie();
      }, []);

      return (
        <UitkLayoutGridItem colSpan={colSpan} className="GroundTransportationLocation">
          <div>
            <UitkLayoutGrid className="numberOfColumns" space="two">
              <Viewport>
                <ViewSmall>
                  <>
                    <GroundTransportLocationField
                      context={context}
                      fieldConfig={originConfig!}
                      fieldInvalidKey={originInvalidKey}
                      location={location.origin}
                      onLocationFieldUpdate={onOriginLocationFieldUpdate}
                      setInputsRefs={setInputsRefs}
                      track={track}
                      trackId={originRfrr}
                      colSpan={smallViewColSpan}
                    />
                    <GroundTransportSwitch
                      onSwapTypeheadLocations={onSwapTypeheadLocations}
                      colSpan={smallViewColSpan}
                    />
                    <GroundTransportLocationField
                      context={context}
                      fieldConfig={destinationConfig!}
                      fieldInvalidKey={destinationInvalidKey}
                      location={location.destination}
                      onLocationFieldUpdate={onDestinationLocationFieldUpdate}
                      setInputsRefs={setInputsRefs}
                      track={track}
                      trackId={destinationRfrr}
                      colSpan={smallViewColSpan}
                    />
                  </>
                </ViewSmall>
                <ViewLarge>
                  <>
                    <GroundTransportLocationField
                      context={context}
                      fieldConfig={originConfig!}
                      fieldInvalidKey={originInvalidKey}
                      location={location.origin}
                      onLocationFieldUpdate={onOriginLocationFieldUpdate}
                      setInputsRefs={setInputsRefs}
                      track={track}
                      trackId={originRfrr}
                      colSpan={lcoationFieldColSpan}
                    />
                    <GroundTransportSwitch onSwapTypeheadLocations={onSwapTypeheadLocations} colSpan={switchColSpan} />
                    <GroundTransportLocationField
                      context={context}
                      fieldConfig={destinationConfig!}
                      fieldInvalidKey={destinationInvalidKey}
                      location={location.destination}
                      onLocationFieldUpdate={onDestinationLocationFieldUpdate}
                      setInputsRefs={setInputsRefs}
                      track={track}
                      trackId={destinationRfrr}
                      colSpan={lcoationFieldColSpan}
                    />
                  </>
                </ViewLarge>
              </Viewport>
            </UitkLayoutGrid>
          </div>
        </UitkLayoutGridItem>
      );
    }
  )
);
